import { productVariantSelectorChangeEvent, productVariantSelectorName, } from '@/components/ui';
import { ProductContext, productContextTagName } from '@/components/utils';
import { Section, defineSection } from '@decify/cell-shopify/client';
import './product-overview.scss';
export const productOverviewName = 'ProductOverview';
export const productOverviewTagName = 'cell-section-product-overview';
export class ProductOverview extends Section {
    templateCache;
    constructor() {
        super(productOverviewName);
        this.templateCache = new Map();
        this.handleProductVariantChange = this.handleProductVariantChange.bind(this);
    }
    componentDidMount() {
        this.subscribe(`${productVariantSelectorName}.${productVariantSelectorChangeEvent}`, this.handleProductVariantChange);
    }
    async handleProductVariantChange(data) {
        const { selectedProductVariant } = data;
        // TODO: Disable relevant actions like buy_buttons to prevent conflicts.
        const template = await this.getTemplateForProductVariant(selectedProductVariant.id);
        this.querySelectorAll('[cell-update]').forEach((element) => {
            const newElement = template.querySelector(`[cell-update="${element.getAttribute('cell-update')}"]`);
            if (newElement) {
                // Replace with a clone of the new element to make sure the original element in the
                // template is not modified.
                element.replaceWith(newElement.cloneNode(true));
            }
        });
    }
    async getTemplateForProductVariant(selectedProductVariantId) {
        let template = this.templateCache.get(selectedProductVariantId);
        if (!template) {
            template = await this.fetchTemplateForProductVariant(selectedProductVariantId);
            this.templateCache.set(selectedProductVariantId, template);
        }
        return template;
    }
    async fetchTemplateForProductVariant(selectedProductVariantId) {
        const context = this.querySelector(productContextTagName);
        if (!context || !(context instanceof ProductContext)) {
            throw new Error('Product context not found');
        }
        const response = await fetch(window.Cell.routes.root +
            'products/' +
            context.product.handle +
            '?variant=' +
            selectedProductVariantId +
            '&section_id=' +
            this.props.sectionId);
        const responseText = await response.text();
        const template = new DOMParser().parseFromString(responseText, 'text/html');
        return template;
    }
}
defineSection(productOverviewTagName, ProductOverview);
